var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"All Timecards","icon":"mdi-timetable","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }